// assets/product-grid-variant.js
function updateVariantId(variantId, element) {
  if (!variantId) return;
  const productCard = element.closest('.yv-product-card');
  if (!productCard) return;
  const form = productCard.querySelector('.product-grid-form');
  if (!form) return;
  const variantInput = form.querySelector('[data-variant-id-input]');
  if (!variantInput) return;
  variantInput.value = variantId;
  form.querySelectorAll('input[name="id"]').forEach(input => {
    input.value = variantId;
  });
}

function updateVariantIdFromSelect(selectElement) {
  const variantId = selectElement.value;
  const productCard = selectElement.closest('.yv-product-card');
  if (!productCard) return;
  const form = productCard.querySelector('.product-grid-form');
  if (!form) return;
  const variantInput = form.querySelector('[data-variant-id-input]');
  if (variantInput && variantId) variantInput.value = variantId;
}

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.color_option input[type="radio"].productOption').forEach(radio => {
    radio.addEventListener('change', function () {
      const variantId = this.getAttribute('data-variant-id');
      if (variantId) updateVariantId(variantId, this);
    });
    radio.addEventListener('click', function () {
      const variantId = this.getAttribute('data-variant-id');
      if (variantId) updateVariantId(variantId, this);
    });
  });
  document.querySelectorAll('[data-bundle-product-option]').forEach(select => {
    select.addEventListener('change', function () {
      updateVariantIdFromSelect(this);
    });
  });
});